import {
  MenuGroups,
  MenuItemEnum,
} from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';

export type MenuTranslation = {
  group: Record<MenuGroups, string>;
  item: Record<MenuItemEnum, string>;
};

export const menuTranslation: MenuTranslation = {
  group: {
    [MenuGroups.ADMIN]: 'needsToBeUpdated',
    [MenuGroups.AREA]: 'needsToBeUpdated',
    [MenuGroups.CERTIFICATION]: 'needsToBeUpdated',
    [MenuGroups.EMPLOYEE_PROFILE]: 'needsToBeUpdated',
    [MenuGroups.EMPLOYEE_PROFILES_SEARCH]: 'Test grupy',
    [MenuGroups.EMPLOYEE_PROFILES_SEARCH_AI]: 'needsToBeUpdated',
    [MenuGroups.GROUP_TRAININGS]: 'needsToBeUpdated',
    [MenuGroups.KNOW_ME]: 'needsToBeUpdated',
    [MenuGroups.NOTIFICATIONS]: 'needsToBeUpdated',
    [MenuGroups.STRUCTURE]: 'needsToBeUpdated',
    [MenuGroups.SUCCESSION]: 'needsToBeUpdated',
    [MenuGroups.TEAM]: 'needsToBeUpdated',
    [MenuGroups.USERS_LIST]: 'needsToBeUpdated',
  },
  item: {
    [MenuItemEnum.ADMIN]: 'Admin Panel',
    [MenuItemEnum.AREA]: 'My area',
    [MenuItemEnum.CERTIFICATION]: 'Certification',
    [MenuItemEnum.CONTACT]: 'Contact',
    [MenuItemEnum.EMPLOYEE_PROFILE]: 'My profile',
    [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH]: 'Employees search',
    [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH_AI]: 'Matching employees to a position',
    [MenuItemEnum.GROUP_TRAININGS]: 'Training for groups',
    [MenuItemEnum.KNOW_ME]: 'KnowMe',
    [MenuItemEnum.NESTED_STRUCTURE]: 'Nested structure',
    [MenuItemEnum.NEWS]: 'News',
    [MenuItemEnum.NOTIFICATIONS]: 'Notifications',
    [MenuItemEnum.ORGANIZATION_CHART]: 'Structure',
    [MenuItemEnum.SUCCESSION]: 'Manage succession',
    [MenuItemEnum.SUCCESSION_CHANGELOG]: 'Succession change log',
    [MenuItemEnum.TEAM]: 'My team',
    [MenuItemEnum.USERS_LIST]: 'Admin Panel',
  },
};
